import { useState } from "react";
// --- swiper ----------------------------------------------------------------
import { Swiper, SwiperSlide } from "swiper/react";
import { FreeMode } from "swiper/modules";
import "swiper/css";
// --- lottie ----------------------------------------------------------------
import Lottie from "lottie-react";
import contactLogo from "../assets/lotties/logo-purple.json";
// --- media ----------------------------------------------------------------
import portFolioVideo from "../assets/videos/portfolio.mp4";
import portFolioVideoMo from "../assets/videos/portfolio-mo.mp4";
import {
  default02,
  kakaoIcon,
  arrowIconNext,
  musicPortfolio01,
  musicPortfolio02,
  musicPortfolio03,
  default01,
  snsIconInsta,
  snsIconYoutube,
  snsIconTiktok,
} from "../assets/images";
// --- style ----------------------------------------------------------------
import "../styles/pages/Portfolio.scss";


function Portfolio() {
  // --- 데이터 ----------------------------------------------------------------
  // 크리에이터
  const creatorsItems = [ // 관련 내용 전달 시 변경 예정
    {
      id: 1,
      img: default01,
      name: "Name Name Name Name",
      instaUrl: "/",
      tiktokUrl: "/",
      youtubeUrl: "/",
    },
    {
      id: 2,
      img: default01,
      name: "Name Name Name Name",
      instaUrl: "/",
      tiktokUrl: "/",
      youtubeUrl: "/",
    },
    {
      id: 3,
      img: default01,
      name: "Name Name Name Name",
      instaUrl: "/",
      tiktokUrl: "/",
      youtubeUrl: "",
    },
    {
      id: 4,
      img: default01,
      name: "Name Name Name Name",
      instaUrl: "",
      tiktokUrl: "",
      youtubeUrl: "/",
    },
    {
      id: 5,
      img: default01,
      name: "Name Name Name Name",
      instaUrl: "/",
      tiktokUrl: "",
      youtubeUrl: "",
    },
    {
      id: 6,
      img: default01,
      name: "Name Name Name Name",
      instaUrl: "",
      tiktokUrl: "/",
      youtubeUrl: "/",
    },
    {
      id: 7,
      img: default01,
      name: "Name Name Name Name",
      instaUrl: "/",
      tiktokUrl: "/",
      youtubeUrl: "/",
    },
    {
      id: 8,
      img: default01,
      name: "Name Name Name Name",
      instaUrl: "",
      tiktokUrl: "/",
      youtubeUrl: "/",
    },
  ]
  // 발매 음반
  const releseItems = [musicPortfolio01, musicPortfolio02, musicPortfolio03, default02] // 이미지 전달 시 default02 이미지 교체
  

  return (
    <div className='page-wrapper portfolio'>
      {/* === VIDEO 영역 === */}
      <div className="home__hero portfolio">
        {/* PC video */}
        <video
          className="hero-video hero-video--pc"
          autoPlay
          muted
          loop
          playsInline
          preload="metadata"
          aria-hidden="true"
        >
          <source src={portFolioVideo} type="video/mp4" />
        </video>

        {/* Mobile video */}
        <video
          className="hero-video hero-video--mo"
          autoPlay
          muted
          loop
          playsInline
          preload="metadata"
          aria-hidden="true"
        >
          <source src={portFolioVideoMo} type="video/mp4" />
        </video>   

        <div className="portfolio__hero">
          <div className="hero-inner max-12">
            <h2 className="gfont tit">
              ALL MAKERS, ONE STAGE
            </h2>
            <span className="subtit">
              모두가 무대 위에서 함께 성장한다
            </span>            
            <p className="desc-01">
              우리는 단순히 콘텐츠를 만드는 팀이 아닙니다<br /> 
              MOB은 AI와 사람, 음악과 영상, 브랜드와 아티스트가 함께 움직이는 실행형 크리에이티브 팀입니다<br />
              MOB 크리에이터는 AI · 음악 · 영상 · 광고 · 행사까지 하나의 무대에서 함께 움직이는 실전형 크루입니다              
            </p>
            <p className="desc-02">
              우리는 단순히 콘텐츠를 올리지 않습니다. <span className="spacing">직접 촬영하고, 공연하고, 브랜드를 제안합니다.</span>
            </p>
            <a 
            href="https://pf.kakao.com/_QLTxgn"
            target="_blank"
            rel="noopener noreferrer"
            >
              MOB와 함께하기
              <img src={arrowIconNext} alt="" aria-hidden="true" />
            </a>
          </div>
        </div>       
      </div>

      {/* === CREATORS === */}
      {/* <section className="portfolio__section max-12">
        <div className="content-section__title">
          <span>그들의 경험이 당신의 음악을 더 깊게 만들어드립니다</span>
          <h3 className="gfont">OUR CREATORS</h3>
        </div>

        <ul className="creators-list">
          {creatorsItems.map((item) => (
            <li key={item.id} style={{ backgroundImage: `url(${item.img})` }}>
                <div className="creators-overlay">
                  <div className="creators-overlay-inner">
                    <h4>{item.name}</h4>
                    <div className="creators-sns">
                      {item.instaUrl && (
                        <a href={item.instaUrl} target="_blank" rel="noopener noreferrer" aria-label="Instagram">
                          <img src={snsIconInsta} alt="" aria-hidden="true" />
                        </a>
                      )}
                      {item.tiktokUrl && (
                        <a href={item.tiktokUrl} target="_blank" rel="noopener noreferrer" aria-label="TikTok">
                          <img src={snsIconTiktok} alt="" aria-hidden="true" />
                        </a>
                      )}
                      {item.youtubeUrl && (
                        <a href={item.youtubeUrl} target="_blank" rel="noopener noreferrer" aria-label="YouTube">
                          <img src={snsIconYoutube} alt="" aria-hidden="true" />
                        </a>
                      )}
                    </div>
                  </div>
                </div>
            </li>
          ))}
        </ul>
      </section> */}

      {/* === INSTRUCTORS === */}
      {/* <section className="portfolio__section max-12">
        <div className="content-section__title">
          <span>그들의 경험이 당신의 음악을 더 깊게 만들어드립니다</span>
          <h3 className="gfont">OUR INSTRUCTORS</h3>
        </div>
      </section> */}

      {/* === LIVE FROM MOB STUDIO (VIDEO SLIDER) === */}
      {/* <section className="portfolio__section max-12">
        <h3 className="gfont">LIVE FROM MOB STUDIO</h3>
      </section>              */}

      {/* === TICKER === */}
      <section className="portfolio__section ticker gfont">
        <div className="ticker__title max-12">
          <p>지금도 많은 분들이</p>
          <h3>음반 제작 발매 중</h3>
        </div>

        <div className="ticker__content">
          <div className="ticker__viewport">
            <div className="ticker__track" aria-hidden="true">
              {releseItems.map((src, i) => (
                <div className="ticker__item" key={`a-${i}`}>
                  <img src={src} alt="" aria-hidden="true" />
                </div>
              ))}
            </div>

            <div className="ticker__track" aria-hidden="true">
              {releseItems.map((src, i) => (
                <div className="ticker__item" key={`b-${i}`}>
                  <img src={src} alt="" aria-hidden="true" />
                </div>
              ))}
            </div>
            <div className="ticker__track" aria-hidden="true">
              {releseItems.map((src, i) => (
                <div className="ticker__item" key={`b-${i}`}>
                  <img src={src} alt="" aria-hidden="true" />
                </div>
              ))}
            </div>            
          </div>
        </div>        
      </section>

      {/* === INQUIRY === */} 
      <div className="content-section__contact">
        <p className="desc">
          ALL MAKERS, ONE STAGE. 지금 당신의 무대를 시작하세요
        </p>
        <h3 className="gfont title">
          CONTACT US
        </h3>
        <Lottie
          animationData={contactLogo}
          loop
          autoplay
          className="contact-lottie"
        />

        <div className="kakao-link">
          <span>지금 시작해 보세요.</span>
          <a 
          href="https://pf.kakao.com/_QLTxgn"
          target="_blank"
          rel="noopener noreferrer"
          >
            <img src={kakaoIcon} alt="" aria-hidden="true" />
            카카오 채널 문의
          </a>
        </div>
      </div>   
    </div>
  )
}

export default Portfolio